
import * as React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClientProvider } from 'react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from '@/lib/auth';
import { queryClient } from '@/lib/react-query';
import { Box, Button, CircularProgress, Typography } from '@mui/material';

const Spinner = () => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', width: '100vw' }}>
    <CircularProgress color="primary" size={60} style={{ marginBottom: 24 }} />
  </div>
);

const ErrorFallback = ({ error, resetErrorBoundary }: { error: Error; resetErrorBoundary: () => void }) => (
  <Box
    className="text-red-500 w-screen h-screen flex flex-col justify-center items-center bg-gray-50"
    role="alert"
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      width: '100%',
      textAlign: 'center',
      padding: 2,
      backgroundColor: '#f8d7da',
      borderRadius: 2,
      boxSizing: 'border-box',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',}}
  >
    <Box sx={{
      width: 100,
      height: 100,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: 2,
      borderRadius: '50%',
      backgroundColor: '#f5c6cb',
      color: '#ff3e3e',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
       
    }}>
      <svg className=" " fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M21 12A9 9 0 113 12a9 9 0 0118 0z" />
    </svg>
    </Box>
    <Typography component={'h2'} sx={{ fontSize: '24px', color: '#ff3e3e', fontWeight: 'bold', marginBottom: 1 }}>Oops, something went wrong!</Typography>
    <Typography component={'p'} sx={{ fontSize: '16px', color: '#333', fontWeight: 'bold', marginBottom: 3 }}>{error?.message || 'An unexpected error occurred.'}</Typography>
    <Button
      onClick={resetErrorBoundary}
      variant="contained"
      color="primary"
      sx={{
        padding: '10px 20px',
        fontSize: '16px',
        backgroundColor: 'rgb(60, 55, 255)',
        marginTop: 2,
        borderRadius: 2,
        color: '#fff',
        '&:hover': {
          backgroundColor: 'rgb(4, 0, 131)',
        },
      }}
    >
      Try Again
    </Button>
  </Box>
);

type AppProviderProps = {
  children: React.ReactNode;
};

export const AppProvider = ({ children }: AppProviderProps) => {
  return (
    <React.Suspense fallback={<Spinner />}>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <HelmetProvider>
          <QueryClientProvider client={queryClient}>
           
            <AuthProvider>
              
              <Router>{children}</Router>
            </AuthProvider>
          </QueryClientProvider>
        </HelmetProvider>
      </ErrorBoundary>
    </React.Suspense>
  );
};